import { render, staticRenderFns } from "./CustomerAccumulationPart.vue?vue&type=template&id=12660424&scoped=true"
import script from "./CustomerAccumulationPart.vue?vue&type=script&lang=js"
export * from "./CustomerAccumulationPart.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccumulationPart.vue?vue&type=style&index=0&id=12660424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12660424",
  null
  
)

export default component.exports